import React from 'react';
import Case1 from './case1';
import Case2 from './case2';
import Case3 from './case3';
import Case4 from './case4';
import Case5 from './case5';
import Case6 from './case6';
import Case7 from './case7';
import Case8 from './case8';
import Case9 from './case9';
import Case10 from './case10';
import Case11 from './case11';
import Case12 from './case12';

const AllCase = () => (
  <>
    <Case1 />
    <Case2 />
    <Case3 />
    <Case4 />
    <Case5 />
    <Case6 />
    <Case7 />
    <Case8 />
    <Case9 />
    <Case10 />
    <Case11 />
    <Case12 />
  </>
);

export default AllCase;
